import { User } from '@utils/backend-api/currentUser';

export function userTitle(
  user: Pick<User, 'title_at_company' | 'company_name'>,
  delimiter = ' - '
) {
  return [user.title_at_company?.trim(), user.company_name?.trim()].filter(Boolean).join(delimiter);
}

export function userName(user: Pick<User, 'name' | 'username'>) {
  return user.name || user.username;
}
